/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagesplanDto } from '../../models/tagesplan-dto';

export interface GetTagesplan$Plain$Params {

/**
 * ID des Tagesplan nach der gesucht werden soll
 */
  id: string;
}

export function getTagesplan$Plain(http: HttpClient, rootUrl: string, params: GetTagesplan$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TagesplanDto>> {
  const rb = new RequestBuilder(rootUrl, getTagesplan$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagesplanDto>;
    })
  );
}

getTagesplan$Plain.PATH = '/v1/tagesplaene/{id}';
